import React from 'react';

interface IconProps {
  width?: string;
  height?: string;
}

export const PatientIcon: React.FC<IconProps> = ({ width = 25, height = 24 }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11 16.2765V18.7235C11 19.331 11.4925 19.8235 12.1 19.8235H14.1765V21.9C14.1765 22.5075 14.669 23 15.2765 23H17.7235C18.331 23 18.8235 22.5075 18.8235 21.9V19.8235H20.9C21.5075 19.8235 22 19.331 22 18.7235V16.2765C22 15.669 21.5075 15.1765 20.9 15.1765H18.8235V13.1C18.8235 12.4925 18.331 12 17.7235 12H15.2765C14.669 12 14.1765 12.4925 14.1765 13.1V15.1765H12.1C11.4925 15.1765 11 15.669 11 16.2765Z'
        stroke='#04A0C5'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path d='M2 20V17C2 14.7909 3.79086 13 6 13H11' stroke='#04A0C5' strokeWidth='2' strokeLinecap='round' />
      <circle cx='9' cy='6' r='4' stroke='#04A0C5' strokeWidth='2' />
    </svg>
  );
};
